export enum PartDetailsScreen {
  PART = 'PartDetailsPart',
  JOBS = 'PartDetailsJobs',
  BATCH = 'PartDetailsBatch',
  NC_FILE = 'PartDetailsNCFile',
  TOOLS = 'PartDetailsTools',
}

export enum PartDetailsScreenLink {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
}

export enum PartLevelSubScreen {
  GENERAL = 'General',
  TIMELINE = 'Timeline',
  DOCUMENTS = 'Documents',
}

export enum PartLevelSubScreenLink {
  GENERAL = 'general',
  TIMELINE = 'timeline',
  DOCUMENTS = 'documents',
}